// @flow
import type {
  ERROR_TYPE,
  COUNTRY_TYPE,
  GEO_POINT_TYPE,
  POINT_TYPE,
} from './common';

export type TRIP_TYPE = {
  id: number,
  route: number,
  name: string,
  short_name: string,
  bus: number,
  monitor: number,
  stops: Array<number>,
  school: number,
  is_completed: boolean,
  isOpen?: boolean,
  isShowingDetail?: boolean,
  trip_type: 'going' | 'returning'
};

export type TRIP_STOP_TYPE = {
  id: number,
  trip: number,
  name: string,
  short_name: string,
  address: string,
  city: string,
  country: COUNTRY_TYPE,
  point: GEO_POINT_TYPE,
  students: Array<number>,
  eta_distance: Object,
  ordinal: number,
  is_completed: boolean,
  path_to_next_stop: Array<POINT_TYPE>
};

export type TRIPS_FETCH_STARTED_TYPE = {
  type: 'TRIPS_FETCH_STARTED'
};
export const TRIPS_FETCH_STARTED = 'TRIPS_FETCH_STARTED';

export type TRIPS_SCHOOL_FETCH_STARTED_TYPE = {
    type: 'TRIPS_SCHOOL_FETCH_STARTED',
    payload: {
      schoolId: number
    }
};
export const TRIPS_SCHOOL_FETCH_STARTED = 'TRIPS_SCHOOL_FETCH_STARTED';

export type TRIP_FETCH_STARTED_TYPE = {
  type: 'TRIP_FETCH_STARTED',
  payload: number
};
export const TRIP_FETCH_STARTED = 'TRIP_FETCH_STARTED';

export type SINGLE_TRIP_FETCH_STARTED_TYPE = {
  type: 'SINGLE_TRIP_FETCH_STARTED',
  payload: number
};
export const SINGLE_TRIP_FETCH_STARTED = 'SINGLE_TRIP_FETCH_STARTED';

export type TRIPS_SCHOOL_FETCH_SUCCESS_TYPE = {
    type: 'TRIPS_SCHOOL_FETCH_SUCCESS',
    payload: {
        entities: {[number]: TRIP_TYPE},
        order: Array<number>
    }
};
export const TRIPS_SCHOOL_FETCH_SUCCESS = 'TRIPS_SCHOOL_FETCH_SUCCESS';

export type TRIPS_ADMIN_FETCH_STARTED_TYPE = {
    type: 'TRIPS_ADMIN_FETCH_STARTED',
    payload: {
        userId: number
    }
};
export const TRIPS_ADMIN_FETCH_STARTED = 'TRIPS_ADMIN_FETCH_STARTED';

export type TRIPS_ADMIN_FETCH_SUCCESS_TYPE = {
    type: 'TRIPS_ADMIN_FETCH_SUCCESS',
    payload: {
        entities: {[number]: TRIP_TYPE},
        order: Array<number>
    }
};
export const TRIPS_ADMIN_FETCH_SUCCESS = 'TRIPS_ADMIN_FETCH_SUCCESS';

export type TRIPS_FETCH_SUCCEED_TYPE = {
  type: 'TRIPS_FETCH_SUCCEED',
  payload: {
    entities: { [number]: TRIP_TYPE }
  }
};
export const TRIPS_FETCH_SUCCEED = 'TRIPS_FETCH_SUCCEED';

export type TRIPS_FETCH_FAILED_TYPE = {
  type: 'TRIPS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const TRIPS_FETCH_FAILED = 'TRIPS_FETCH_FAILED';

export type TRIP_FETCH_SUCCEED_TYPE = {
  type: 'TRIP_FETCH_SUCCEED',
  payload: TRIP_TYPE
};
export const TRIP_FETCH_SUCCEED = 'TRIP_FETCH_SUCCEED';

export type TRIP_UPDATED_TYPE = {
  type: 'TRIP_UPDATED',
  payload: {
    id: number
  }
};
export const TRIP_UPDATED = 'TRIP_UPDATED';

export type TRIP_FETCH_FAILED_TYPE = {
  type: 'TRIP_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const TRIP_FETCH_FAILED = 'TRIP_FETCH_FAILED';

export type TRIP_ADDED_TYPE = {
  type: 'TRIP_ADDED',
  payload: TRIP_TYPE
};
export const TRIP_ADDED = 'TRIP_ADDED';

export type TRIP_REMOVED_TYPE = {
  type: 'TRIP_REMOVED',
  payload: number
};
export const TRIP_REMOVED = 'TRIP_REMOVED';

export type TRIP_SELECTED_TYPE = {
  type: 'TRIP_SELECTED',
  payload: number
};
export const TRIP_SELECTED = 'TRIP_SELECTED';

// export type TRIP_DESELECTED_TYPE = {
//   type: 'TRIP_DESELECTED',
//   payload: number
// };
// export const TRIP_DESELECTED = 'TRIP_DESELECTED';

export type TRIP_COMPLETED_TYPE = {
  type: 'TRIP_COMPLETED',
  payload: {
    id: number,
    is_completed: true
  }
};
export const TRIP_COMPLETED = 'TRIP_COMPLETED';

export type TRIP_STOPS_FETCH_STARTED_TYPE = {
  type: 'TRIP_STOPS_FETCH_STARTED',
  payload: {
    id: number
  }
};
export const TRIP_STOPS_FETCH_STARTED = 'TRIP_STOPS_FETCH_STARTED';

export type TRIP_STOPS_FETCH_SUCCEED_TYPE = {
  type: 'TRIP_STOPS_FETCH_SUCCEED',
  payload: {
    entities: {[number]: TRIP_STOP_TYPE}
  }
};
export const TRIP_STOPS_FETCH_SUCCEED = 'TRIP_STOPS_FETCH_SUCCEED';

export type TRIP_STOPS_FETCH_FAILED_TYPE = {
  type: 'TRIP_STOPS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const TRIP_STOPS_FETCH_FAILED = 'TRIP_STOPS_FETCH_FAILED';

export type TRIP_STOP_COMPLETED_TYPE = {
  type: 'TRIP_STOP_COMPLETED',
  payload: {
    id: number,
    is_completed: boolean
  }
};
export const TRIP_STOP_COMPLETED = 'TRIP_STOP_COMPLETED';

export type TRIP_STOP_REMOVED_TYPE = {
  type: 'TRIP_STOP_REMOVED',
  payload: number
};
export const TRIP_STOP_REMOVED = 'TRIP_STOP_REMOVED';

export type TRIP_STOP_ADDED_TYPE = {
  type: 'TRIP_STOP_ADDED',
  payload: TRIP_STOP_TYPE
};
export const TRIP_STOP_ADDED = 'TRIP_STOP_ADDED';

export type TRIP_OPENED_TYPE = {
  type: 'TRIP_OPENED',
  payload: {
    id: number,
    isOpen: boolean
  }
};
export const TRIP_OPENED = 'TRIP_OPENED';

export type TRIP_CLOSED_TYPE = {
  type: 'TRIP_CLOSED',
  payload: {
    id: number,
    isOpen: boolean
  }
};
export const TRIP_CLOSED = 'TRIP_CLOSED';

export type TRIP_STOP_UPDATED_TYPE = {
  type: 'TRIP_STOP_UPDATED',
  payload: TRIP_STOP_TYPE
};
export const TRIP_STOP_UPDATED = 'TRIP_STOP_UPDATED';

export type TRIP_DETAIL_SHOWN_TYPE = {
  type: 'TRIP_DETAIL_SHOWN',
  payload: {
    id: number,
    isShowingDetail: true
  }
};
export const TRIP_DETAIL_SHOWN = 'TRIP_DETAIL_SHOWN';

export type TRIP_DETAIL_HIDDEN_TYPE = {
  type: 'TRIP_DETAIL_HIDDEN',
  payload: {
    id: number,
    isShowingDetail: false
  }
};
export const TRIP_DETAIL_HIDDEN = 'TRIP_DETAIL_HIDDEN';

export type TRIP_CREATION_STARTED_TYPE = {
  type: 'TRIP_CREATION_STARTED'
};
export const TRIP_CREATION_STARTED = 'TRIP_CREATION_STARTED';

export type TRIP_CREATION_FAILED_TYPE = {
  type: 'TRIP_CREATION_FAILED',
  payload: ERROR_TYPE
};
export const TRIP_CREATION_FAILED = 'TRIP_CREATION_FAILED';

export type TAKE_TRIP_ASSISTANCE_STARTED_TYPE = {
  type: 'TAKE_TRIP_ASSISTANCE_STARTED'
};
export const TAKE_TRIP_ASSISTANCE_STARTED = 'TAKE_TRIP_ASSISTANCE_STARTED';

export type TAKE_TRIP_ASSISTANCE_SUCCEED_TYPE = {
  type: 'TAKE_TRIP_ASSISTANCE_SUCCEED'
};
export const TAKE_TRIP_ASSISTANCE_SUCCEED = 'TAKE_TRIP_ASSISTANCE_SUCCEED';

export type TAKE_TRIP_ASSISTANCE_FAILED_TYPE = {
  type: 'TAKE_TRIP_ASSISTANCE_FAILED'
};
export const TAKE_TRIP_ASSISTANCE_FAILED = 'TAKE_TRIP_ASSISTANCE_FAILED';

export type FINISH_TRIP_STARTED_TYPE = {
  type: 'FINISH_TRIP_STARTED',
  payload: ID_TYPE,
}
export const FINISH_TRIP_STARTED = 'FINISH_TRIP_STARTED';

export type FINISH_TRIP_SUCCEED_TYPE = {
  type: 'FINISH_TRIP_SUCCEED',
}
export const FINISH_TRIP_SUCCEED = 'FINISH_TRIP_SUCCEED';

export type FINISH_TRIP_FAILED_TYPE = {
  type: 'FINISH_TRIP_FAILED',
  payload: ERROR_TYPE,
}
export const FINISH_TRIP_FAILED = 'FINISH_TRIP_FAILED';

export type TRIPS_ACTION_TYPE =
  | TRIPS_FETCH_STARTED_TYPE
  | TRIPS_FETCH_SUCCEED_TYPE
  | TRIPS_FETCH_FAILED_TYPE
  | TRIPS_SCHOOL_FETCH_STARTED_TYPE
  | TRIPS_SCHOOL_FETCH_SUCCESS_TYPE
  | TRIP_FETCH_STARTED_TYPE
  | TRIP_FETCH_SUCCEED_TYPE
  | TRIP_FETCH_FAILED_TYPE
  | TRIP_ADDED_TYPE
  | TRIP_REMOVED_TYPE
  | TRIP_SELECTED_TYPE
  | TRIP_OPENED_TYPE
  | TRIP_CLOSED_TYPE
  | TRIP_COMPLETED_TYPE
  | TRIP_DETAIL_SHOWN_TYPE
  | TRIP_DETAIL_HIDDEN_TYPE
  | TRIP_STOPS_FETCH_STARTED_TYPE
  | TRIP_STOPS_FETCH_SUCCEED_TYPE
  | TRIP_STOPS_FETCH_FAILED_TYPE
  | TRIP_STOP_COMPLETED_TYPE
  | TRIP_STOP_REMOVED_TYPE
  | TRIP_STOP_ADDED_TYPE
  | TRIP_STOP_UPDATED_TYPE
  | TRIP_CREATION_STARTED_TYPE
  | TRIP_CREATION_FAILED_TYPE
  | TAKE_TRIP_ASSISTANCE_STARTED_TYPE
  | TAKE_TRIP_ASSISTANCE_SUCCEED_TYPE
  | TAKE_TRIP_ASSISTANCE_FAILED_TYPE
  | TRIP_UPDATED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/trips.js